import { render, staticRenderFns } from "./SubmittedResult.vue?vue&type=template&id=049319d4&scoped=true&"
import script from "./SubmittedResult.vue?vue&type=script&lang=js&"
export * from "./SubmittedResult.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedResult.vue?vue&type=style&index=0&id=049319d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049319d4",
  null
  
)

export default component.exports